import styled from "styled-components";
import * as mq from "../../styles/mediaQueries";
export const FormAccordionWrapper = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const FormWrapper = styled.form`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;
export const Wrapper = styled.div`
  width: ${props => (props.fullWidth ? "100%" : "50%")};
  display: inline-block;
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: ${props => (props.margin ? "12px" : "24px")};
  @media (max-width: 576px) {
    width: 100%;
    margin-bottom: 16px;
    padding-left: 8px;
    padding-right: 8px;
    .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root,
    .css-p0rm37 {
      transform: translate(14px, 11px) scale(1);
      font-size: 14px;
    }
    .css-1kty9di-MuiFormLabel-root-MuiInputLabel-root,
    .css-1rcvyyg {
      transform: translate(14px, -6px) scale(0.75);
      font-size: 14px;
    }
  }
`;
export const CollectionWrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;
export const AgeWrapper = styled.p`
  position: relative;
  z-index: 9;
  height: 0;
  width: 100px;
  top: -35px;
  left: 70%;
  font-size: 14px;
  color: var(--primary-color);
  font-family: "Inter";
  font-weight: 500;
  margin: 0;
  ${mq.sm} {
    width: 70px;
    left: 80%;
    top: -30px;
    font-size: 12px;
  }
`;

// Document Upload

export const ErrorMsg = styled.div`
  color: #d8000c;
  font-size: 10px;
  padding: 5px 0;
  margin-left: 15px;
`;

export const FileInputWrapper = styled.div`
  width: 30%;
  ${mq.sm} {
    width: 100%;
  }
  text-align: center;
  & .file_name_container {
    display: inline-block;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & input {
    text-align: center;
    width: 100%;
    display: none;
  }
  & input[type="file"]::file-selector-button {
    display: none;
  }
`;
export const UploaderBody = styled.div`
  margin: 10px 0;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  padding: 25px 5px;
  width: 100%;
  ${mq.sm} {
    padding: 10px 5px;
  }
  .upload_btn {
    background-color: ${props =>
      props.active ? "#f2581b !important" : "#f0f0f0 !important"};
    color: ${props => (props.active ? "white !important" : "black !important")};
  }
  & .file_name_container {
    display: ${props => (props.active ? "inline-block" : "none")};
    ${mq.sm} {
      padding: 0 10px;
    }
  }
  & .additional-doc-input {
    width: 64%;
    text-align: left;
    
  }
  .upload__body {
    align-items: center;
    justify-content: space-between;
    display: flex;
    ${mq.sm} {
      justify-content: flex-start;
      flex-wrap: wrap;
      gap: 0.5em;
    }
    
  }
  .additional-body {
    align-items: center;
    justify-content:flex-end;
    display: flex;
    padding:0 15px;
    ${mq.sm} {
      justify-content: flex-start;
      flex-wrap: wrap;
      gap: 0.5em;
    }
`;
export const UploadWrap = styled.div`
  width: 50%;
  display: inline-block;
  padding: 0 15px;

  ${mq.sm} {
    width: 100%;
    padding: 0 10px;
  }
`;

export const UploadPanel = styled.div`
  width: 870px;

  margin-bottom: 24px;
  ${mq.sm} {
    padding: 12px 5px 30px;
    width: 100%;
  }
  hr {
    width: 90%;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border: 1px solid white !important;
  }
  & .panel_fotter {
    p {
      color: #e63030;
      font-size: 13px;
      line-height: 12px;
      font-weight: 900;
      padding: 10px;
      width: 100%;
      text-align: center;
      font-family: Poppinsblck;
      ${mq.sm} {
        font-size: 12px;
        padding: 10px 5px;
      }
    }
    button {
      border-radius: 2px;
      width: 100%;
      font-family: "Poppins";
      line-height: 50px;
      padding: 0 40px;
      font-size: 16px;
      color: #ffffff;
      text-transform: uppercase;
      margin: 18px -7px;
      background: var(--primary-color);
    }
  }
  & .panel_heading {
    color: #000;
    font-size: 24px;
    line-height: 28px;
    padding: 10px;
    width: 100%;
    font-weight: 900;
    ${mq.sm} {
      font-size: 13px;
      padding: 10px 2px;
    }
  }
  & .panel_heading_desc {
    color: #e63030;
    font-size: 13px;
    line-height: 12px;
    font-weight: 900;
    padding: 10px;
    width: 100%;
    background: #fff2f4;
    text-align: center;
    font-family: Poppinsblck;
    ${mq.sm} {
      font-size: 10px;
    }
  }

  & .trash-icon {
    color: #e63030;
    font-size: 18px;
    cursor: pointer;
  }
  & .select_wrapper {
    label {
      font-size: 14px;
      color: #57667e;
    }
    .Choose_file_btn {
      width: 135px;
      text-align: center;
      margin-right: 5px;
      background-color: var(--primary-color);
      border-radius: 6px !important;
      padding: 11px 20px;
      cursor: pointer;
      display: inline-block;
      color: #fff;
      font-size: 14px;
      border: none;
      ${mq.sm} {
        width: 40%;
        padding: 7px;
        margin: 10px;
      }
    }
    .upload_btn {
      background: #f0f0f0;
      border: none;
      margin-right: 5px;
      width: 135px;
      text-align: center;
      border-radius: 6px !important;
      padding: 11px 20px;
      cursor: pointer;
      display: inline-block;
      color: #fff;
      font-size: 14px;
      ${mq.sm} {
        width: 40%;
        padding: 7px;
        margin: 10px;
      }
    }
  }
  p {
    margin: 0px !important;
  }
`;
export const Button = styled.button`
  text-align: center;
  display: flex;
  width: 40%;
  gap: 1em;
  cursor: pointer;
  font-size: 15px;
  font-family: "Inter";
  font-weight: 400;
  ${mq.sm} {
    width: 100%;
    justify-content: center;
    font-size: 12px;
  }
  & .add-icon {
    color: var(--primary-color);
    background: #aed4fc;
    padding: 5px;
    width: 1.6em;
    height: 1.6em;
    border-radius: 50%;
    ${mq.sm} {
      padding: 3px;
    }
  }
  & .add-text {
    font-weight: 600;
  }
`;
